import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { GlobeDemo } from "../ui/worldglobe";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";

function Hero() {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const handleDashboardClick = () => {
    if (user) {
      navigate('/strategy/dashboard');
    } else {
      navigate('/signin');
    }
  };

  return (
    <div className="relative overflow-hidden bg-[#d6eaf8] rounded-[2rem] mx-4 my-8 sm:mx-8 lg:rounded-[4rem]">
      <div className="80rem mx-auto flex flex-col lg:flex-row items-center lg:items-start">
        <div className="relative z-10 pb-8 sm:pb-16 md:pb-20 lg:w-1/2 lg:pb-28 xl:pb-32">
          <main className="mt-10 mx-auto px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div className="text-center lg:text-left">
              <h1 className="text-3xl tracking-tight font-extrabold text-black sm:text-4xl md:text-5xl lg:text-6xl">
                <span className="block">Effortless Expansion into MENAP Markets</span>
              </h1>
              <p className="mt-3 text-sm text-black sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-8 md:text-xl lg:mx-0">
                Grow your brand in the Middle East, North Africa, and Pakistan with a streamlined, all-in-one platform providing fast delivery, full localization, and optimized marketplace access.
              </p>
              <div className="mt-10 flex flex-col sm:flex-row sm:justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4">
                <Link
                  to="/contact"
                  className="w-full flex items-center justify-center px-6 py-3 text-base font-medium rounded-full text-[#0049ac] bg-white hover:bg-white/90 sm:px-8 md:py-4 md:text-lg md:px-10 shadow-md hover:scale-105 transform transition-all duration-300"
                >
                  Get Started
                </Link>
                <button
                  onClick={handleDashboardClick}
                  className="w-full flex items-center justify-center px-6 py-3 text-base text-[#1c2833] font-medium rounded-full bg-[#808b96] hover:bg-[#6c757d] sm:px-8 md:py-4 md:text-lg md:px-10 shadow-md hover:scale-105 transform transition-all duration-300"
                >
                  Launch Dashboard
                  <ArrowRightIcon className="ml-2 h-5 w-5" />
                </button>
              </div>
            </div>
          </main>
        </div>
        
        {/* Globe section with original size and position for desktop */}
        <div className="relative w-full lg:w-1/2 flex justify-center lg:justify-end">
          <div className="w-[27.5rem] h-[27.5rem] sm:w-[30rem] sm:h-[30rem] md:w-[35rem] md:h-[35rem] lg:w-[40rem] lg:h-[40rem]  flex items-center justify-center">
            <GlobeDemo />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
